var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackInctive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.27,
    height: 22.27,
    viewBox: "0 0 22.27 22.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2403",
    d: "M0-682.665H22.27v22.27H0Z",
    transform: "translate(0 682.665)",
    stroke: "#262626",
    strokeWidth: 1.333
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feedback_Inactive",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2399",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2401",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2407",
    transform: "translate(0.652 7.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2409",
    d: "M-490.137-100.607v7.481a1.3,1.3,0,0,1-1.3,1.3h-12.614l-2.61,1.74v-12.614a1.3,1.3,0,0,1,1.3-1.3h8.351",
    transform: "translate(506.665 104)",
    fill: "rgba(0,0,0,0)",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2411",
    transform: "translate(12.918 0.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2413",
    d: "M-167.678-103.187v-2.175a1.3,1.3,0,0,0-1.3-1.3,1.3,1.3,0,0,0-1.3,1.3v.534a2.175,2.175,0,0,1-1.577,2.091l-1.467.419v4.567a3.021,3.021,0,0,0,2.623,1.522h4.336a1.74,1.74,0,0,0,1.74-1.74v-3.48a1.74,1.74,0,0,0-1.74-1.74Z",
    transform: "translate(173.333 106.666)",
    fill: "rgba(0,0,0,0)",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2415",
    d: "M316-549.039h2.61V-556H316Z",
    transform: "translate(-305.691 560.131)",
    fill: "rgba(0,0,0,0)",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2417",
    transform: "translate(3.262 11.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2419",
    d: "M0,0H4.35",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2421",
    transform: "translate(3.262 14.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2423",
    d: "M0,0H11.309",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2425",
    transform: "translate(3.262 16.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2427",
    d: "M0,0H11.309",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackInctive);
export default __webpack_public_path__ + "static/media/feedback_inctive.9f08a862.svg";
export { ForwardRef as ReactComponent };